import * as React from 'react'
import type {
  CardClosingRequirements,
  ENTITY_TYPES,
} from '@sales-center/common'
import { Layout } from '../atoms'
import { RequirementsDataGrid } from '../atoms/RequirementsDataGrid.styled'
import { useData } from './useData'
import { useColumns } from './hooks/useColumns'
import { useLocalizationDateFormat } from '@user/features/Localization/useLocalizationDateFormat'
import { IForm } from '@user/store/agreements'

export type Props = {
  billToId: string
  canUpdate: boolean
  entityId: number
  entityType: ENTITY_TYPES
  externalLocationId: string
  requirementsAndCounts: CardClosingRequirements
  openAgreementCreateDrawer?: (formData?: IForm) => void
}

export function AgreementsTable(props: Props) {
  const {
    requirementsAndCounts: { agreementsCount },
  } = props

  const { agreements, loading } = useData(props)
  const { formatDate } = useLocalizationDateFormat()
  const columns = useColumns(props, agreements)

  const localizedColumns = columns?.map((row) => {
    if (row.type == 'date' || row.type == 'dateTime') {
      return {
        ...row,
        valueFormatter: (params) => formatDate(params.value, row.type),
      }
    }
    return row
  })

  return (
    <Layout
      count={agreementsCount}
      title="Agreements"
      dataTestId="agreementsTable"
      table={
        <RequirementsDataGrid
          autoHeight
          disableRowSelectionOnClick
          disableColumnMenu
          hideFooter
          rows={agreements}
          columns={localizedColumns}
          loading={loading}
          pagination={false}
        />
      }
    />
  )
}
